import type { MicroAppDataMode } from "@/types";

/**
 * Plain-language labels + consequences for a micro app's data modes (the
 * "whose data, and is it live?" framing — see
 * docs/MICRO_APPS_DATAPROVIDER_GENERALIZATION.md §13). Used by the publish
 * dialog (author chooser) and the viewer trust badge so the naming stays
 * coherent end-to-end.
 */

export interface DataModeCopy {
  /** Short label (freshness + source). */
  label: string;
  /** One-line consequence shown under the label in the author chooser. */
  consequence: (sourceLabel: string) => string;
}

export const DATA_MODE_COPY: Record<MicroAppDataMode, DataModeCopy> = {
  caller: {
    label: "Live · personal",
    consequence: (s) => `Each viewer needs their own access to ${s}, or they see nothing.`,
  },
  author: {
    label: "Live · shared by you",
    consequence: (s) => `Anyone you share with sees live ${s} data using your access — you're responsible for it.`,
  },
  snapshot: {
    label: "Snapshot",
    consequence: () => "A frozen copy from publish time; never updates.",
  },
};

/** Ordered modes for the chooser (personal → shared → frozen). */
export const DATA_MODE_ORDER: MicroAppDataMode[] = ["caller", "author", "snapshot"];

export function dataModeLabel(mode: string): string {
  return (DATA_MODE_COPY as Record<string, DataModeCopy>)[mode]?.label ?? mode;
}
